
console.log("Init");
if (!window.global)
  window.global = window as any; // HACK

export class Initialization {
  static init(): void {
  }
}